module.exports = __webpack_public_path__ + "media/app/img/logo-9ff4509db8fa7848eac6ee870d7f721c.png";